// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"be27567e","301":"3dea0c1b","453":"bc5a26f7"}[chunkId] + ".chunk.js";
};